<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      fixed
      color="secondary"
      :temporary="$vuetify.breakpoint.smAndDown"
      style="width: 268px"
    >
      <v-list class="pt-1 pb-0" style="pointer-events: none">
        <v-list-item link>
          <v-img
            contain
            max-height="80"
            aspect-ratio="3"
            src="@/assets/sastra_logo.png"
          />
        </v-list-item>
      </v-list>

      <v-divider class="pa-0"></v-divider>
      <v-list dense>
        <div v-for="item in menuTree" :key="item.id">
          <v-list-group
            v-if="item.children.length && itemGroupHasAccess(item)"
            v-model="item.active"
            active-class="primary--text"
          >
            <template v-slot:activator>
              <v-list-item-icon class="mr-3">
                <v-icon color="primary">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="primary--text">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <template v-for="c in item.children">
              <v-list-item
                v-if="hasAccess(c)"
                :key="c.id"
                :to="{ name: c.module_name }"
                active-class="primary--text"
                class="pl-10"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon color="primary">
                    {{ c.icon }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="primary--text"
                    style="white-space: normal; word-break: break-word"
                    >{{ c.title }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
          <template v-else>
            <v-list-item
              v-if="hasAccess(item) && getMenuTitle(item.title)"
              router-link
              :to="{ name: item.module_name }"
              exact
              active-class="primary--text"
            >
              <v-list-item-icon class="mr-3">
                <v-icon color="primary">
                  {{ item.icon }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="primary--text text-3xl text-wrap pa-1"
                  >{{ item.title }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </template>
        </div>
      </v-list>
      <div class="d-flex justify-center my-2">
        <v-chip small>v{{ currentVersion }}</v-chip>
      </div>
    </v-navigation-drawer>
    <v-app-bar elevation="0" clipped-left color="primary" height="60px">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-breadcrumbs
        v-if="$store.state.breadcrumbs && $store.state.breadcrumbs.length"
        :items="$store.state.breadcrumbs"
        class="pa-0 app-breadcrumbs"
      >
        <template v-slot:divider>
          <span class="secondary--text text-2xl font-weight-medium title"
            >/</span
          >
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.to"
            :disabled="!item.to"
            exact
            class="secondary--text text-2xl font-weight-medium title breadcrumb-link"
            :style="{
              textDecoration: item.to ? 'underline' : 'none',
              cursor: item.to ? 'pointer' : 'auto',
            }"
          >
            {{ item.text ? item.text.toUpperCase() : "" }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <v-spacer></v-spacer>
      <v-menu left bottom max-width="250" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon class="secondary--text"> mdi-account-circle </v-icon>
          </v-btn>
          <span
            style="font-size: 13px !important"
            class="text-caption white--text"
            >{{
              userData.name
                ? userData.name.charAt(0).toUpperCase() + userData.name.slice(1)
                : "-"
            }}</span
          >
        </template>

        <v-card class="pa-0" elevation="8" rounded="lg">
          <!-- User Info Section with Divider -->
          <v-list dense>
            <v-list-item>
              <v-list-item-content class="font-weight-bold text-primary">
                <v-list-item-title>
                  Name: {{ userData.name ? userData.name : "-" }}
                </v-list-item-title>
                <v-list-item-title>
                  Email: {{ userData.email ? userData.email : "-" }}
                </v-list-item-title>
                <v-list-item-title>
                  Mobile No: {{ userData.mobile_no }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="my-2"></v-divider>

            <!-- Dropdown Items Section -->
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, i) in dropItem"
                :key="i"
                @click="handleAction(item?.action)"
                :to="item?.to"
                class="rounded-lg"
              >
                <v-list-item-icon>
                  <v-icon class="text-primary"> {{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>
      <v-icon
        v-if="showRolesList"
        color="white"
        @click="showHelpdeskDialog = true"
        >mdi-help-circle</v-icon
      >
      <v-dialog v-model="showHelpdeskDialog" width="500" persistent>
        <confirmationDialog
          v-if="showHelpdeskDialog"
          :confirmationText="`This action will redirect you to the Helpdesk portal. Do you wish to proceed?`"
          @closeDialog="showHelpdeskDialog = false"
          @saveDialog="
            showHelpdeskDialog = false;
            navigateToHelpdesk();
          "
        />
      </v-dialog>
    </v-app-bar>
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
import packageJson from "../../package.json";
import confirmationDialog from "@/components/confirmationDialog.vue";
import env from "@/helpers/env";
export default {
  components: { confirmationDialog },
  data() {
    return {
      env: env,
      drawer: true,
      menu: false,
      dropItem: [{ text: "Sign out", icon: "mdi-logout", action: "signOut" }],
      currentVersion: "",
      showHelpdeskDialog: false,
      menuItems: [],
    };
  },
  computed: {
    userData() {
      return this.$store.state.currentUser;
    },
    role() {
      return this.$store.state.currentUser.role;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    showRolesList() {
      return this.role !== "Admin" && this.role !== "Management";
    },
    // Builds the sidebar tree from the flat menu_items list fetched from the
    // backend (see Menu Builder / ChalknBoard.Menu) — this is the single
    // source of truth for menu structure now, not a hardcoded array here.
    menuTree() {
      const byId = {};
      this.menuItems.forEach((item) => {
        byId[item.id] = { ...item, children: [] };
      });
      const roots = [];
      this.menuItems.forEach((item) => {
        const node = byId[item.id];
        if (item.parent_id && byId[item.parent_id]) {
          byId[item.parent_id].children.push(node);
        } else if (!item.parent_id) {
          roots.push(node);
        }
      });
      const bySortOrder = (a, b) => a.sort_order - b.sort_order;
      roots.sort(bySortOrder);
      roots.forEach((root) => root.children.sort(bySortOrder));
      return roots;
    },
  },
  created() {
    this.currentVersion = packageJson.version;
    this.getMenuItems();
  },
  watch: {},
  methods: {
    async getMenuItems() {
      await this.$axios.get("menu_items").then((res) => {
        // The sidebar only ever renders visible items — hidden ones (detail
        // routes with no nav link of their own, e.g. "View Partner") exist
        // purely so a role can be granted access to them via Roles/Menu
        // Builder, not to appear here.
        this.menuItems = res.data.data.filter((item) => item.visible);
      });
    },
    // Sidebar visibility is decided per PLACEMENT, by currentUser.menu_item_ids
    // — the specific menu_item ids the backend granted (role grants plus any
    // flag-based bonus, e.g. a partner flag unlocking "Partner"/"Business"
    // role pages — see ChalknBoard.Common.effective_menu_item_ids/1). This is
    // deliberately NOT a check against currentUser.modules (module names):
    // the same route can appear twice with different audiences (e.g. "Request
    // Fee" under Payments for Admin/Management/Reviewer, and again under
    // Collections Report for CFO only) — both share a module name, so a
    // name-only check can't tell the two placements apart and would leak
    // CFO's link to Admin and vice versa. A group header (a menu item with
    // children but no id of its own worth checking) isn't itself granted;
    // its visibility is derived from its children instead — see
    // itemGroupHasAccess. Route reachability (typing the URL directly) is a
    // separate, module-name-based check in router/index.js — if a role has
    // any placement of a page, the page itself stays reachable either way.
    hasAccess(entry) {
      if (!entry || !entry.id) return false;
      return (
        Array.isArray(this.currentUser?.menu_item_ids) &&
        this.currentUser.menu_item_ids.includes(entry.id)
      );
    },
    itemGroupHasAccess(item) {
      if (!item.children || !item.children.length) return false;
      return item.children.some((c) => this.hasAccess(c));
    },
    signOut() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push("/");
    },
    handleAction(action) {
      if (typeof this[action] === "function") {
        this[action]();
      } else {
        console.log(`Action "${action}" is not defined as a method.`);
      }
    },
    navigateToHelpdesk() {
      const authToken = localStorage.getItem("token");

      if (authToken) {
        const newWindow = window.open(
          `${env.base_url}/helpdesk?token=${authToken}`,
          "_blank",
        );
        if (newWindow) {
          newWindow.focus();
        }
      } else {
        this.showError("Authentication token not found. Please log in again.");
      }
    },
    getMenuTitle(itemTitle) {
      const hasBulkAccess =
        this.currentUser?.partner_payment_required ||
        this.currentUser?.role == "Reviewer";
      if (
        !hasBulkAccess &&
        ["Set Bulk Payments", "Bulk Payments"].includes(itemTitle)
      ) {
        return false;
      }

      if (
        hasBulkAccess &&
        [
          "Transaction History",
          "Set Payment Options",
          "Loan Payments",
        ].includes(itemTitle)
      ) {
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>
.v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:first-child {
  color: white;
}
.title {
  font-size: 14px !important;
}
::v-deep .app-breadcrumbs a,
::v-deep .app-breadcrumbs .v-breadcrumbs__item,
::v-deep .app-breadcrumbs .v-breadcrumbs__item--disabled {
  color: var(--v-secondary-base, #fff) !important;
  opacity: 1 !important;
}
::v-deep .app-breadcrumbs a:hover,
::v-deep .app-breadcrumbs a:visited {
  color: var(--v-secondary-base, #fff) !important;
}
.image-content {
  height: 40px !important;
  padding: 28px;
}
</style>
